import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DatabaseProvider } from './contexts/DatabaseContext';
import Home from './pages/Home';
import Menu from './pages/Menu';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import CustomerDashboard from './pages/CustomerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import DeliveryDashboard from './pages/DeliveryDashboard';
import OrderDetails from './pages/OrderDetails';
import UserProfile from './pages/UserProfile';
import Privacy from './pages/Privacy';
import FAQ from './pages/FAQ';
import Help from './pages/Help';
import Terms from './pages/Terms';
import Checkout from './pages/Checkout';
import Payment from './pages/Payment';
import OrderConfirmation from './pages/OrderConfirmation';
import OrdersList from './pages/OrdersList';
import AddOrder from './pages/AddOrder';
import FileComplaint from './pages/FileComplaint';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import ChatBot from './components/ChatBot';
import QuickAccess from './components/QuickAccess';
import ProtectedRoute from './components/ProtectedRoute';
export function App() {
  const [cookieAccepted, setCookieAccepted] = useState(false);
  useEffect(() => {
    const hasConsented = localStorage.getItem('cookieConsent');
    if (hasConsented) {
      setCookieAccepted(true);
    }
  }, []);
  return <Router data-id="element-0">
      <DatabaseProvider data-id="element-1">
        <AuthProvider data-id="element-2">
          <div className="flex flex-col min-h-screen bg-amber-50" data-id="element-3">
            <Navbar data-id="element-4" />
            <main className="flex-grow" data-id="element-5">
              <Routes data-id="element-6">
                <Route path="/" element={<Home data-id="element-8" />} data-id="element-7" />
                <Route path="/menu" element={<Menu data-id="element-10" />} data-id="element-9" />
                <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
                <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
                <Route path="/login" element={<Login data-id="element-16" />} data-id="element-15" />
                <Route path="/register" element={<Register data-id="element-18" />} data-id="element-17" />
                <Route path="/customer" element={<ProtectedRoute requiredUserType="customer" data-id="element-20">
                      <CustomerDashboard data-id="element-21" />
                    </ProtectedRoute>} data-id="element-19" />
                <Route path="/admin" element={<ProtectedRoute requiredUserType="admin" data-id="element-23">
                      <AdminDashboard data-id="element-24" />
                    </ProtectedRoute>} data-id="element-22" />
                <Route path="/delivery" element={<ProtectedRoute requiredUserType="delivery" data-id="element-26">
                      <DeliveryDashboard data-id="element-27" />
                    </ProtectedRoute>} data-id="element-25" />
                <Route path="/order/:id" element={<ProtectedRoute data-id="element-29">
                      <OrderDetails data-id="element-30" />
                    </ProtectedRoute>} data-id="element-28" />
                <Route path="/profile" element={<ProtectedRoute data-id="element-32">
                      <UserProfile data-id="element-33" />
                    </ProtectedRoute>} data-id="element-31" />
                <Route path="/privacy" element={<Privacy data-id="element-35" />} data-id="element-34" />
                <Route path="/faq" element={<FAQ data-id="element-37" />} data-id="element-36" />
                <Route path="/help" element={<Help data-id="element-39" />} data-id="element-38" />
                <Route path="/terms" element={<Terms data-id="element-41" />} data-id="element-40" />
                <Route path="/checkout" element={<ProtectedRoute data-id="element-43">
                      <Checkout data-id="element-44" />
                    </ProtectedRoute>} data-id="element-42" />
                <Route path="/payment" element={<ProtectedRoute data-id="element-46">
                      <Payment data-id="element-47" />
                    </ProtectedRoute>} data-id="element-45" />
                <Route path="/order-confirmation" element={<ProtectedRoute data-id="element-49">
                      <OrderConfirmation data-id="element-50" />
                    </ProtectedRoute>} data-id="element-48" />
                <Route path="/orders" element={<ProtectedRoute data-id="element-52">
                      <OrdersList data-id="element-53" />
                    </ProtectedRoute>} data-id="element-51" />
                <Route path="/add-order" element={<ProtectedRoute data-id="element-55">
                      <AddOrder data-id="element-56" />
                    </ProtectedRoute>} data-id="element-54" />
                <Route path="/complaint/:orderId" element={<ProtectedRoute data-id="element-58">
                      <FileComplaint data-id="element-59" />
                    </ProtectedRoute>} data-id="element-57" />
              </Routes>
            </main>
            <Footer data-id="element-60" />
            <CookieConsent data-id="element-61" />
            <ChatBot data-id="element-62" />
            <QuickAccess data-id="element-63" />
          </div>
        </AuthProvider>
      </DatabaseProvider>
    </Router>;
}